
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Naming Conventions`}</h1>
<p>{`Always favor creating long and descriptive names.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const p = { x: 2, y: 3 };

// Good
const point = { x: 2, y: 3 };
`}</code></pre>
<p>{`Use `}<inlineCode parentName="p">{`camelCase`}</inlineCode>{` when naming variables, functions and methods.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const FooBar = 2;
const an_object = {};
const iTeMs = [];

// Good
const fooBar = 2;
const anObject = {};
const items = [];
`}</code></pre>
<p>{`Use `}<inlineCode parentName="p">{`PascalCase`}</inlineCode>{` when naming classes.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
class person {
  constructor(name) {
    this.name = name;
  }
}

const john = new person('John');

// Good
class Person {
  constructor(name) {
  }
}

const john = new Person('John');
`}</code></pre>
<p>{`A base filename should match the name of the default export if it's a `}<inlineCode parentName="p">{`class`}</inlineCode>{` or a `}<inlineCode parentName="p">{`kebab-cased`}</inlineCode>{` version if it's anything else.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
import Person from './person';
import fooBar from './fooBar';

// Good
import Person from './Person';
import fooBar from './foo-bar';
`}</code></pre>
<p>{`Acronyms and initialisms should never be uppercased, they should follow normal naming conventions.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? A long string of uppercase characters make reading difficult.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
const HTTPRequest = null;
const GPSPosition = null;
const GPSByIP = null;

// Good
const httpRequest = null;
const gpsPosition = null;
const gpsByIp = null;
`}</code></pre>
<p>{`Constant values that are never gonna change and that are not inside a block, should be all `}<inlineCode parentName="p">{`UPPERCASED`}</inlineCode>{` and `}<inlineCode parentName="p">{`SNAKE_CASED`}</inlineCode>{`.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const friction_coeff = 0.5;

function foo(arg) {
  const ITEMS = [];
  ITEMS.push(arg);
  return ITEMS;
}

// Good
const FRICTION_COEFF = 0.5;

function foo(arg) {
  const items = [];
  items.push(arg);
  return items;
}
`}</code></pre>
<p>{`For consistency, events should be named `}<inlineCode parentName="p">{`e`}</inlineCode>{`.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
document.addEventListener('click', (event) => {
});

// Good
document.addEventListener('click', (e) => {
});
`}</code></pre>
<p>{`For consistency, errors should be named by default `}<inlineCode parentName="p">{`err`}</inlineCode>{`.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
try {
}
catch (error) {
}

// Good
try {
}
catch (err) {
}
`}</code></pre>
<p>{`Always name functions and methods as the infinitive or imperative tense of the verb.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const person = new Person();
person.walking();

// Good
const person = new Person();
person.walk();

// Exception
// When a boolean is returned in a getter

// Bad
person.getWalking();

// Good
person.isWalking();
`}</code></pre>
<p>{`##### `}<strong parentName="p">{`NOTE`}</strong>{`: Rule of thumb here, the name should always feel like an action to be done when calling the function.`}</p>
<p>{`Always name variables as nouns. Always use adjectives to differentiate them.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const deleteItem = items.pop();  // verb + noun

const items1 = items.filter((x) => x % 2 !== 0);  // noun + suffix
const items2 = items.filter((x) => x % 2 === 0);  // noun + suffix

// Good
const deletedItem = items.pop();  // adj + noun

const oddItems = items.filter((x) => x % 2 !== 0);  // adj + noun
const evenItems = items.filter((x) => x % 2 === 0);  // adj + noun
`}</code></pre>
<h5><strong parentName="h5">{`NOTE`}</strong>{`: Rule of thumb here, the name should always feel like it refers to an entity.`}</h5>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;